import {Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter} from '@angular/core';
import {MailTemplate} from '@models/adminstration/organization/mail/mail-template';
import {MAIL_TEMPLATE_TYPE} from '@constants/administration/organization/mail-template/mail-template-type';
import {MAIL_PLACEHOLDERS} from '@constants/administration/organization/mail-template/mail-placeholders';

@Component({
    selector: 'scitis-admin-organization-mail-template',
    templateUrl: './mail-template.component.html',
    styleUrls: ['./mail-template.component.scss'],
    standalone: false
})
export class MailTemplateComponent implements OnInit, OnChanges {

  placeholders: string[] = new Array<string>();

  @Input()
  template: MailTemplate = new MailTemplate();

  @Input()
  templateType: MAIL_TEMPLATE_TYPE = MAIL_TEMPLATE_TYPE.WELCOME_EMAIL;

  @Input()
  isAdminRole: boolean = false;

  @Input()
  isSuperAdminRole: boolean = false;

  focusedControl: any;

  @Output()
  validMailEvent = new EventEmitter<boolean>();

  constructor() {
    this.placeholders = Array.from(Object.values(MAIL_PLACEHOLDERS));
  }

  ngOnInit(): void {
    if (!this.template.height) {
      this.template.height = 300;
    }
  }

  onFocusControl($event: any) {
    this.focusedControl = $event.currentTarget;
  }

  onMessageAreaResize($event: any) {
    const control = $event.currentTarget;
    if (control && control.offsetHeight) {
      this.template.height = control.offsetHeight;
    }
  }

  onAddPlaceholder(placeholder: string) {
    const input = this.focusedControl;

    if (!input) {
      return;
    }
    const scrollPos = input.scrollTop;
    const posStart = input.selectionStart;
    const posEnd = input.selectionEnd;

    const inputText = input.value;
    const textBeforeSelection = inputText.substring(0, posStart);
    const textAfterSelection = inputText.substring(posEnd, inputText.length);
    input.value = textBeforeSelection + placeholder + textAfterSelection;

    input.selectionStart = posStart;
    input.selectionEnd = posStart;
    input.focus();
    input.scrollTop = scrollPos;

    if (input.name === 'subject') {
      this.template.subject = textBeforeSelection + placeholder + textAfterSelection;
    } else if (input.name === 'message') {
      this.template.message = textBeforeSelection + placeholder + textAfterSelection;
    }
    this.isMailCorrectlyDefined(this.template);
  }

  private isMailCorrectlyDefined(template: MailTemplate): void {

    if (this.isPropertyNullOrUndefined(template)) {
      this.validMailEvent.emit(false);
      return;

    }
    const subject = template.subject;
    if (this.isPropertyNullOrUndefined(subject) || subject.length === 0) {
      this.validMailEvent.emit(false);
      return;
    }

    const message = template.message;
    if (this.isPropertyNullOrUndefined(message) || message.length === 0) {
      this.validMailEvent.emit(false);
      return;
    }
    this.validMailEvent.emit(true);
  }

  private isPropertyNullOrUndefined(property: MailTemplate | string): boolean {
    return property === null || property === undefined;
  }

  onValueChange() {
    this.isMailCorrectlyDefined(this.template);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.template && !changes.template.isFirstChange()) {
      this.isMailCorrectlyDefined(this.template);
    }
  }
}
